import { useMemo } from 'react'
import { usePaymentValues } from '@order/hooks/usePaymentValues'
import { useMultiOrderTotal } from '@order/hooks/useOrderTotal'
import {
  usePaymentItems,
  usePaymentItemsMethods,
} from '@order/hooks/usePaymentMethods'
import { PaymentDetails } from '@order/hooks/usePayments'
import { SavedOrder } from '@order/hooks/state/orderState'
import { useOrdersScenarios } from '@order/hooks/useScenario'
import { usePaymentOrders } from './usePaymentOrders'

const EMPTY_ORDERS: SavedOrder[] = []

export const usePaymentDetails = (item: PaymentDetails) => {
  const cartOrders = usePaymentOrders(item.orderIds)
  const savedOrders =
    cartOrders.length > 0 ? cartOrders : item.sourceOrders ?? EMPTY_ORDERS
  const orderTotal = useMultiOrderTotal(savedOrders)

  const discounts = useMemo(() => {
    return savedOrders.map((order) => order.discounts).flat()
  }, [savedOrders])

  const getValues = usePaymentValues({
    orderTotal,
    discounts,
  })

  const paymentItems = usePaymentItems(savedOrders)

  const { methods, defaultMethod, merged } =
    usePaymentItemsMethods(paymentItems)

  const items = savedOrders.flatMap((order) => order.order.items)
  const orders = savedOrders.flatMap((order) => order.result?.orders ?? [])

  const scenarios = useOrdersScenarios(items.map((item) => item.id))

  return {
    items,
    orders,
    discounts,
    getValues,
    methods,
    orderIds: orders.map((res) => res.id),
    defaultMethod,
    payment: item,
    scenarios,
    merged,
  }
}
